// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._82FgA {\n  -webkit-box-shadow: var(--schoolinks-shadow);\n          box-shadow: var(--schoolinks-shadow);\n}\n\n.ZfzCm {\n  border-radius: var(--schoolinks-container-border-radius);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shadow": "_82FgA",
	"rounded": "ZfzCm"
};
export default ___CSS_LOADER_EXPORT___;
